<template>
  <div class="container p-4 document-detail">
    <button class="btn btn-secondary mb-3" @click="goHome">Volver</button>
    <div class="detail-header mb-4">
      <h1 class="detail-title">{{ displayNote?.Nombre }}</h1>
      <p v-if="displayNote?.Fecha_Publicacion" class="detail-date">
        <strong>Fecha:</strong> {{ displayNote.Fecha_Publicacion }}
      </p>
    </div>
    <div class="detail-body mb-4" v-if="displayNote?.Cuerpo" v-html="parseLinks(displayNote.Cuerpo)"></div>
    <div v-if="pdfs.length" class="detail-pdfs mb-4">
      <div class="contact-info-residencias mb-4"
        v-if="displayNote?.id == 57 || (displayNote?.Nombre && displayNote.Nombre.toLowerCase().includes('residencia'))">
        <p class="mb-0"><strong>Ministerio de Salud de San Juan</strong></p>
        <p class="mb-0">División Residencias en Salud</p>
        <p class="mb-0">TEL: 4305511</p>
        <p class="mb-0">E-Mail: <a
            href="mailto:examenresidencias.sanjuan@gmail.com">examenresidencias.sanjuan@gmail.com</a></p>
      </div>
      <h4>Descargar archivos adjuntos:</h4>
      <ul class="pdf-list">
        <li v-for="pdf in pdfs" :key="pdf.id">
          <a :href="getPdfUrl(pdf)" target="_blank" class="pdf-link">
            <i class="fa fa-file-pdf-o pdf-icon"></i>
            {{ pdf.filename_download || pdf.title || "Descargar PDF" }}
          </a>
        </li>
      </ul>
    </div>
    <div v-if="!displayNote">
      <p>Cargando...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentDetailView",
  props: {
    note: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localNote: null,
      pdfs: [],
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    note() {
      this.loadData();
    }
  },
  computed: {
    displayNote() {
      return this.localNote || this.note;
    },
  },
  methods: {
    loadData() {
      if (this.note) {
        this.localNote = this.note;
        if (!this.note.Cuerpo) {
          this.applyFallback(this.note.id);
        } else {
          this.applyFallbackPdfs(this.note.id);
        }
      } else {
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        if (id) {
          this.applyFallback(id);
        }
      }
    },
    applyFallback(id) {
      if (id == 57) {
        this.localNote = {
          id: 57,
          Nombre: "Bibliografía examen Residencias San Juan 2026",
          Fecha_Publicacion: "2026-02-13",
          Cuerpo: "Ministerio de Salud de San Juan<br>División Residencias en Salud<br>TEL: 4305511<br>E-Mail: examenresidencias.sanjuan@gmail.com"
        };
        this.applyFallbackPdfs(57);
      } else if (id == 36) {
        this.localNote = {
          id: 36,
          Nombre: "Programas de Formación de Residencias",
          Fecha_Publicacion: "2025-02-18",
          Cuerpo: "Programas de formación de residencias del equipo de salud de la Provincia de San Juan."
        };
        this.applyFallbackPdfs(36);
      } else if (id == 34) {
        this.localNote = {
          id: 34,
          Nombre: "Residencias del Equipo de Salud - Información General",
          Fecha_Publicacion: "2024-09-24",
          Cuerpo: "Información general sobre las Residencias del Equipo de Salud de la Provincia de San Juan."
        };
        this.applyFallbackPdfs(34);
      } else if (id == 39) {
        this.localNote = {
          id: 39,
          Nombre: "CRONOGRAMA CONCURSO RESIDENCIAS EN SALUD 2026",
          Fecha_Publicacion: "2026-02-27",
          Cuerpo: `Concurso Provincial de Ingreso a las Residencias en Salud de la Provincia de San Juan Ciclo 2026

FECHA DE EXAMEN DE INGRESO A LAS RESIDENCIAS EN SALUD: 28/05/2026
INSCRIPCIONES: DEL 11 DE MARZO AL 10 DE ABRIL DE 2026
REQUISITOS DE INSCRIPCIÓN:
Los siguientes Requisitos deberán entregarse en una Carpeta A4 con frente transparente identificada con carátula en la que conste: Apellido y Nombre, DNI, Domicilio, Teléfonos, Mail, Especialidad para la cual se presenta como postulante y año de la Convocatoria.

A-1) TÍTULO PROFESIONAL O CERTIFICADO DE TÍTULO EN TRÁMITE: Fotocopia legalizada del Título Profesional habilitante o Certificado de Título en trámite, otorgado por Universidad Nacional Pública o Privada habilitada por el Estado Nacional.

A-1-2) TÍTULO PROFESIONAL EXTRANJERO: Fotocopia legalizada del Título Profesional habilitante, otorgado por Universidad Extranjera con la correspondiente reválida de Universidad Nacional y Ministerio de Educación de la Nación Legalizado por autoridad universitaria competente.

A-2) CERTIFICADO ANALÍTICO DEFINITIVO O PROVISORIO: Fotocopia legalizada del certificado analítico de estudio definitivo o provisorio, debiendo constar en él, PROMEDIO FINAL de la carrera, INCLUYENDO LOS APLAZOS. Este certificado deberá ser expedido por Autoridad Universitaria de competencia y legalizado por la Universidad respectiva. No tienen validez puntajes conceptuales, ni ningún otro agregado que no sea promediado como lo son los puntos por Internado Rotatorio o cualquier figura similar.

A-3) FOTOCOPIA DE DNI: Frente y dorso del Documento Nacional de Identidad (Legalizada).

A-4) CERTIFICADO DE REINCIDENCIA O CONSTANCIA DE SU TRÁMITE (art. 8, Ley 22117): Provisto por el Registro Nacional de Reincidencia del Ministerio de Justicia, Seguridad y Derechos Humanos de la Nación. EN ORIGINAL y FECHA ACTUALIZADA ( www.dnrec.jus.gov.ar ).

A-5) CERTIFICADOS DE SALUD PSICOFÍSICA ACTUALIZADOS: Expedidos por Autoridad Sanitaria del sector público o privado (Certificado Psíquico por Profesional Psicólogo y Certificado Clínico por Profesional Médico).

A-6) ANTIGÜEDAD: para residencias básicas se debe registrar antigüedad no superior a diez (10) años de obtenido su título universitario habilitante, mientras que para las residencias post-básicas el plazo será de hasta quince (15) años o menos desde el momento de obtención del título de grado. El cálculo será computado desde la fecha de expedición del título respectivo a la fecha de cierre de la inscripción del concurso en el que se postule. Para aquellos aspirantes que hayan realizado su formación de grado en el extranjero, se tiene en cuenta la fecha de expedición del título de su Universidad de origen, sin que tenga validez la fecha de la convalidación del mismo.

A-7) SEGUNDA RESIDENCIA: Quedan incluidos en la presente convocatoria aquellos profesionales que previamente hubieren completado una residencia sea básica, post básica o articulada, en Instituciones y/o Universidades nacionales, provinciales o privadas, reconocida y acreditada por organismos específicos que garantizan la calidad de la formación, sea Ministerio de Salud de la Nación, Ministerio de Educación de la Nación, Sociedades Científicas.

A-8) ARRAIGO REGIONAL: Para certificar el arraigo regional el postulante debe acreditar domicilio en la Provincia de San Juan mediante su DNI, caso contrario debe presentar partida de nacimiento, certificado de residencia o constancia de voto que acredite un mínimo de permanencia de 2 años en la Provincia de San Juan.

A-9) CONSTANCIA ACTUALIZADA DE CUIL ( www.anses.gov.ar ).

TODAS LAS COPIAS DEBEN ESTAR LEGALIZADAS EN LA OFICINA DEL REGISTRO DE PROFESIONALES EN EL 3° PISO DE CENTRO CÍVICO, DE LUNES A VIERNES DE 8 A 12 hs., PARA LO CUAL DEBEN SER PRESENTADAS CON SU RESPECTIVO ORIGINAL.

PARA LA CONVVOCATORIA A CONCURSO 2026 SOLO PUEDEN INSCRIBIRSE ENFERMEROS QUE HAYAN COMPLETADO EL CICLO DE GRADO UNIVERSITARIO (LICENCIADOS EN ENFERMERIA).

CONTACTO: COORDINACIÓN DE RESIDENCIAS - SECRETARÍA DE PLANIFICACIÓN Y

CONSULTAR NORMAS LEGALES: Resolución N° 5275-MSP-2023 "Reglamento Básico General para Residencias del Equipo de Salud de la Provincia de San Juan" - ANEXO I - Capítulos 3, 5, 6, 7 y 8 – y Resolución N° 1134-MS-2026 "Bases para el Concurso Provincial de Ingreso a las Residencias en Salud de la Provincia de San Juan – Ciclo 2026 - ANEXO I".`
        };
        this.applyFallbackPdfs(39);
      } else if (id == 99) {
        this.localNote = {
          id: 99,
          Nombre: "bibliografia  BioIngieneria",
          Fecha_Publicacion: "2025-03-03",
          Cuerpo: "Bibliografía para la residencia de Bioingeniería / Ingeniería Clínica 2026."
        };
        this.applyFallbackPdfs(99);
      } else if (id == 101) {
        this.localNote = {
          id: 101,
          Nombre: "Especialidades y cupos 2026",
          Fecha_Publicacion: "2026-03-11",
          Cuerpo: "Especialidades y cupos disponibles para el Concurso Provincial de Ingreso a las Residencias en Salud de la Provincia de San Juan - Ciclo 2026."
        };
        this.applyFallbackPdfs(101);
      } else if (id == 103) {
        this.localNote = {
          id: 103,
          Nombre: "Examen Ingreso a Residencias 2026 - 28 de Mayo de 2026",
          Fecha_Publicacion: "2026-05-11",
          Cuerpo: `Examen Provincial de Residencias en Salud 2026 (Especialidades Médicas, RISAMC, Enfermería y Bioquímica, Kinesiología Cardiorrespiratoria, Ingeniería Clínica, Psicología Clínica, Trabajo Social en Salud, y Post básicas: Neonatología, Terapia Intensiva Infantil y Hematología).
Instituciones Privadas (CIMAC - CASTAÑO - SANATORIO ARGENTINO).

DIA: 28 de MAYO de 2026
Lugar: Casa España - Rivadavia 32 (este) frente a Plaza 25 de Mayo - San Juan.
Es Obligatorio llevar DNI y Comprobante con el N° de Inscripción.

· 7:30 hs. Apertura de la Sede de Examen - Casa España.
· 8 hs. Apertura de mesas de asistencia. Ingreso a las aulas.
· 9 a 13 hs. Examen (duración 4 horas).

Respecto al Examen:
- Usted puede llevar lápiz y goma, completar primero la grilla con lápiz negro para poder realizar correcciones sin dañar la hoja. Antes de entregar repasar con lapicera negra, único color que se admite para trabajar en las grillas.

- No está permitido el uso de teléfonos celulares, relojes smartwatch u otros dispositivos electrónicos con conexión a internet durante el examen.

- Dispone de 4 horas para la realización del examen.

- Al finalizar el examen se deben entregar el cuadernillo del examen y la grilla.

FECHAS POSTERIORES IMPORTANTES
- Entrevistas por Competencias para postulantes: Desde el 29 de mayo (Especialidad, Sede y horario a confirmar por mail).

- Publicación Provisoria de notas y reclamo: 13 de Julio.

- Recurso de Revisión de Examen y Apelación: Del 13 al 15 de Julio (Modalidad y horario a confirmar).

- Respuestas al Recurso de Revisión: Del 15 al 17 de julio.

- Publicación de Orden de Mérito - Resultados Definitivos: 21 de Julio. [LINK:http://www.salud.sanjuan.gob.ar|www.salud.sanjuan.gob.ar] y en Centro Cívico 3º piso - Núcleo 2.

- Adjudicación de Cargos: 5 de agosto (Especialidad, Modalidad y horario a confirmar).

- Curso Obligatorio en "Control de Infecciones y Uso apropiado de Recursos para Profesionales de la Salud en formación": Del 18 al 28 de agosto (Especialidad, Sede y horario a confirmar por mail).

- Inicio de Residencia en Sede Formadora: 1 de septiembre.`
        };
        this.applyFallbackPdfs(103);
      } else if (id == 104) {
        this.localNote = {
          id: 104,
          Nombre: "Cronograma de Entrevistas para Postulantes - Concurso 2026",
          Fecha_Publicacion: "2026-05-15",
          Cuerpo: `El Ministerio de Salud de la Provincia de San Juan informa el cronograma oficial para la etapa de Entrevistas por Competencias, correspondiente al Concurso de Residencias en Salud 2026.

Información Importante para el Postulante:
- Puntualidad: Presentarse 15 minutos antes del horario asignado.
- Documentación: Llevar Documento Nacional de Identidad (DNI) físico y vigente.
- Formato: Las entrevistas se realizarán de forma estrictamente presencial.
- Obligatoriedad: Las entrevistas son obligatorias, pero no excluyentes.
- Inasistencia: la inasistencia a la misma no excluye al postulante de posteriores instancias del concurso.

Para consultas o reclamos administrativos, comunícate exclusivamente al correo oficial de la Coordinación de Residencias: examenresidencias.sanjuan@gmail.com`
        };
        this.applyFallbackPdfs(104);
      } else if (id == 105) {
        this.localNote = {
          id: 105,
          Nombre: "Exámenes y grillas de corrección de Residencias en Salud - Concurso 2026",
          Fecha_Publicacion: "2026-07-03",
          Cuerpo: `El Ministerio de Salud de San Juan informa a todos los profesionales que rindieron el examen de ingreso a las Residencias en Salud – Concurso 2026, que ya se encuentran disponibles para su descarga los exámenes de ingreso a las Residencias en Salud, rendidos el pasado 28 de mayo de 2026. Junto con los exámenes, se publican las correspondientes grillas de respuestas correctas.

Esta publicación tiene como objetivo que los postulantes puedan acceder al material oficial, cotejar los datos con sus propias grillas de examen y, en caso de considerarlo necesario, participar fundamentadamente en la instancia de apelación de preguntas.

Los archivos se encuentran adjuntos al final de esta nota, ordenados por cada especialidad y disciplina. Se recuerda a los aspirantes revisar atentamente los cronogramas vigentes para presentar las impugnaciones dentro de los plazos legales establecidos.`
        };
        this.applyFallbackPdfs(105);
      } else if (id == 106) {
        this.localNote = {
          id: 106,
          Nombre: "Notas de Examen de Ingreso a las Residencias en Salud",
          Fecha_Publicacion: "2026-07-13",
          Cuerpo: `El Ministerio de Salud de la Provincia de San Juan, a través de la División Recursos Humanos y Capacitación (Área Coordinación de Residencias), informa que ya está disponible la Publicación Provisoria de Notas de Examen de Ingreso a las Residencias en Salud.

Concluida la etapa de Publicación Provisoria de Notas de Examen de Ingreso a las Residencias en Salud se abrirá la instancia de Revisión de Examen y Apelación de preguntas.

Cronograma de fechas importantes:
Tras la publicación provisoria de las calificaciones, se habilitará la instancia de revisión y apelación de preguntas bajo el siguiente cronograma oficial:

13 al 15 de julio: Presentación del Recurso de Revisión de Examen y Apelación. (Se enviará un correo electrónico con el instructivo del proceso).
15 al 17 de julio: Envío de respuestas a los recursos presentados.
21 de julio: Publicación del Orden de Mérito Definitivo.

Se solicita a los profesionales revisar periódicamente sus bandejas de entrada y carpetas de correo no deseado (spam) para no perder las notificaciones importantes del concurso.

Por consultas o dudas, el canal oficial de comunicación es: examenresidencias.sanjuan@gmail.com`
        };
        this.applyFallbackPdfs(106);
      } else if (id == 107) {
        this.localNote = {
          id: 107,
          Nombre: "Respuestas a la instancia de apelaciones",
          Fecha_Publicacion: "2026-07-17",
          Cuerpo: `El Ministerio de Salud de la Provincia de San Juan, a través de la División Recursos Humanos y Capacitación (Área Coordinación de Residencias), informa que ya se encuentran disponibles las respuestas a los Recursos de Revisión de Examen y Apelación presentados por los postulantes al Concurso Provincial de Ingreso a las Residencias en Salud - Ciclo 2026.

Por consultas o dudas, el canal oficial de comunicación es: examenresidencias.sanjuan@gmail.com`
        };
        this.applyFallbackPdfs(107);
      } else if (id == 108) {
        this.localNote = {
          id: 108,
          Nombre: "Orden de Mérito Definitivo",
          Fecha_Publicacion: "2026-07-21",
          Cuerpo: `El Ministerio de Salud de la Provincia de San Juan, a través de la División Recursos Humanos y Capacitación (Área Coordinación de Residencias), informa que ya está disponible el Orden de Mérito Definitivo correspondiente a los postulantes a las Residencias en Salud – Concurso 2026.

A partir de esta instancia, los postulantes deben seguir estrictamente los pasos detallados a continuación para asegurar su participación en las próximas etapas del proceso de adjudicación.

Próximas Fechas Clave del Cronograma
5 de agosto: Acto de Adjudicación de Cargos. La especialidad, modalidad y horarios específicos se confirmarán próximamente.
18 al 28 de agosto: Curso obligatorio en "Control de Infecciones y Uso Apropiado de Recursos para Profesionales de la Salud en Formación". Las sedes y horarios se enviarán a cada postulante.
1 de septiembre: Inicio oficial de la Residencia en la sede formadora asignada.

Acciones Requeridas para los Postulantes
Controlar el email: Revisar diariamente la bandeja de entrada y la carpeta de correo no deseado (Spam). Todas las notificaciones y asignaciones de horarios se enviarán por esta vía.
Canal oficial de consultas: Ante cualquier duda o inconveniente administrativo, el único medio habilitado por la Coordinación de Residencias es el correo electrónico oficial: examenresidencias.sanjuan@gmail.com.
Documentación para adjudicación: Recordar que quienes hayan rendido con título en trámite deberán presentar obligatoriamente el título y analítico definitivo en formato físico (copia legalizada por la entidad emisora o por el Registro de Profesionales del Ministerio de Salud) previo al acto público de adjudicación.`
        };
        this.applyFallbackPdfs(108);
      } else if (id == 109) {
        this.localNote = {
          id: 109,
          Nombre: "FE DE ERRATAS DE ORDEN DE MÉRITO RISAMC",
          Fecha_Publicacion: "2026-07-21",
          Cuerpo: `MINISTERIO DE SALUD DE LA PROVINCIA DE SAN JUAN
División Recursos Humanos y Capacitación – Área Coordinación de Residencias
COMUNICADO OFICIAL: Rectificación del Orden de Mérito Definitivo (Concurso 2026)
La Coordinación de Residencias informa que, debido a un error involuntario en la carga de datos, se omitió asignar un (1) punto adicional en la nota de examen de una de las postulantes a la residencia en la Especialidad de Psicología - RISAMC.
Dicho puntaje correspondía ser acreditado en el Orden de Mérito Definitivo de las postulantes a esa especialidad de residencia en Salud (Concurso 2026), publicado en el día de la fecha según el cronograma oficial.
Esta Coordinación pide disculpas por los inconvenientes que este error pudiera ocasionar, y comunica que ya se está procediendo a realizar la rectificación correspondiente para garantizar la total transparencia y equidad en el proceso de selección.`
        };
        this.applyFallbackPdfs(109);
      } else if (id == 110) {
        this.localNote = {
          id: 110,
          Nombre: "ACTO DE ADJUDICACIÓN DE BECAS DE RESIDENCIAS 2026",
          Fecha_Publicacion: "2026-07-31",
          Cuerpo: `Comunicación Oficial: Adjudicación de Becas de Residencias

El Ministerio de Salud de la Provincia de San Juan informa que la adjudicación de becas de residencias se realizará de forma virtual (online), en cumplimiento con las normativas provinciales vigentes.

Fecha y hora del Acto de Adjudicación:
5 de agosto de 2026, a partir de las 14 horas.

Requisitos Técnicos
Para el desarrollo del acto de adjudicación, cada aspirante debe disponer de:
- Conexión a internet estable.
- Dispositivo con cámara y micrófono (celular, notebook, PC o tablet).

Modalidad del Acto
- Ingreso: Acceda a la sala virtual en el día y horario asignado para su especialidad.
- Tolerancia: Habrá 15 minutos de tolerancia desde el horario de inicio antes de comenzar el llamado.
- Llamado por Orden de Mérito: Se convocará a los aspirantes según el Orden de Mérito Definitivo publicado.
- Identificación: Al ser llamado, deberá mostrar su DNI ante la cámara.
- Ausencias: Si no responde al llamado virtual, se lo llamará una única vez al teléfono registrado en su inscripción. Si tampoco responde, se continuará con el siguiente postulante de la lista.

Consideraciones Importantes
- Documentación: Es condición obligatoria tener la documentación completa (Título y Analítico definitivos). Quienes no cumplan con esto no podrán adjudicar.
- Cupos Privados: Los postulantes para especialidades con vacantes en instituciones privadas podrán elegir dichos cargos durante este mismo acto.
- Transparencia: El proceso contará con la presencia y validación de la Escribana Mayor de Gobierno (o quien ella designe).

Próximos Pasos
En los próximos días recibirá un correo electrónico con el link de acceso a su reunión virtual.

Se solicita a los profesionales revisar periódicamente sus bandejas de entrada y carpetas de correo no deseado (spam) para no perder las notificaciones importantes del concurso.

Por consultas o dudas, el canal oficial de comunicación es: examenresidencias.sanjuan@gmail.com`
        };
        this.applyFallbackPdfs(110);
      } else if (id == 111) {
        this.localNote = {
          id: 111,
          Nombre: "Curso Obligatorio en Control de Infecciones y Uso Apropiado de Recursos",
          Fecha_Publicacion: "2026-08-12",
          Cuerpo: `Comunicado Oficial: Curso Obligatorio para Ingresantes a Residencias en Salud 2026
El Ministerio de Salud de la Provincia de San Juan informa la realización del "Curso en Control de Infecciones y Uso Apropiado de Recursos". Esta capacitación es de carácter obligatorio para todos los profesionales ingresantes a las Residencias del Equipo de Salud (Concurso 2026).

🗓️ Datos del Evento
Fechas: Miércoles 26 y jueves 27 de agosto de 2026.
Horario: De 14:00 a 17:00 horas.
Lugar: Sala de Conferencias de la Dirección de Obra Social Provincia (subsuelo).
Dirección: Agustín Gnecco 360 (Sur), Ciudad de San Juan.

📩 Próximos Pasos y Acciones Requeridas
Envío de especificaciones: En los próximos días recibirás un correo electrónico con los detalles técnicos del curso.
Revisión de casillas: Se solicita controlar periódicamente la bandeja de entrada y la carpeta de correo no deseado (Spam) para no perder ninguna notificación.

✉️ Canales de Consulta
Para resolver dudas o realizar consultas, el único canal oficial habilitado es: examenresidencias.sanjuan@gmail.com`
        };
      } else if (id == 112) {
        this.localNote = {
          id: 112,
          Nombre: "INSTANCIA DE PRIMERA READJUDICACIÓN DE BECAS VACANTES",
          Fecha_Publicacion: "2026-09-08",
          Cuerpo: `Comunicación Oficial: Readjudicación de Becas Vacantes Concurso de Residencias 2026
El Ministerio de Salud de la Provincia de San Juan informa que se encuentra disponible el listado de becas vacantes de residencias para la instancia de readjudicación, en cumplimiento con las normativas provinciales vigentes.

🗓️ Cronograma de Fechas Importantes
Del 8 al 11 de septiembre: Publicación de Vacantes en www.salud.sanjuan.gob.ar.
14 y 15 de septiembre: Inscripción definitiva.
17 y 18 de septiembre: Entrevistas por competencias (especialidad, sede y horario a confirmar por correo electrónico).
23 de septiembre: Publicación del Orden de Mérito de la 1ra Readjudicación en www.salud.sanjuan.gob.ar.
25 de septiembre: Adjudicación de cargos de la 1ra Readjudicación (especialidad, modalidad y horario a confirmar).
1 de octubre: Inicio de la residencia en la sede formadora.

📋 Requisitos e Información Importante para Aspirantes
Proceso de Inscripción: Al momento de inscribirse a la beca vacante, deberá enviar un correo electrónico manifestando explícitamente su interés en participar y, de corresponder, el cambio de especialidad solicitado.
Entrevistas: Esta instancia rige únicamente para aquellos profesionales que no pudieron realizar la entrevista en la primera convocatoria.
Criterio de Selección: El Orden de Mérito se confeccionará respetando estrictamente el resultado final obtenido en las instancias previas.`
        };
        this.applyFallbackPdfs(112);
      } else if (id == 113) {
        this.localNote = {
          id: 113,
          Nombre: "ORDEN DE MÉRITO 1° READJUDICACIÓN",
          Fecha_Publicacion: "2026-09-17",
          Cuerpo: `Comunicación Oficial: Órden de Mérito 1° Readjudicación de Becas Vacantes Concurso de Residencias 2026

El Ministerio de Salud de la Provincia de San Juan informa que se encuentra disponible el Órden de Mérito de la 1° Readjudicación de becas vacantes de residencias, Concurso 2026.

En cumplimiento con las normativas provinciales vigentes la Resolución N° 5275-2023, ART. 51 - inc. 6°, establece: "El nuevo órden de mérito es publicado en fecha establecida por cronograma público, se conformará un único ranking por profesión, y se podrá elegir especialidad y sede de residencia por órden de mérito al momento de la toma del cargo".

Cronograma de Fechas Importantes

25 de septiembre: Adjudicación de cargos de la 1ra Readjudicación (especialidad, modalidad y horario a confirmar).

1 de octubre: Inicio de la residencia en la sede formadora.`
        };
        this.applyFallbackPdfs(113);
      } else if (id == 114) {
        this.localNote = {
          id: 114,
          Nombre: "INSTANCIA DE SEGUNDA READJUDICACIÓN DE BECAS VACANTES",
          Fecha_Publicacion: "2026-10-06",
          Cuerpo: `Comunicación Oficial: Segunda Readjudicación de Becas Vacantes Concurso de Residencias 2026
El Ministerio de Salud de la Provincia de San Juan informa que se encuentra disponible el listado de becas vacantes de residencias para la instancia de segunda readjudicación, en cumplimiento con las normativas provinciales vigentes.

🗓️ Cronograma de Fechas Importantes
Del 6 al 9 de octubre: Publicación de Vacantes en www.salud.sanjuan.gob.ar.
13 y 14 de octubre: Inscripción definitiva.
19 y 20 de octubre: Entrevistas por competencias para postulantes (especialidad, sede y horario a confirmar por correo electrónico).
23 de octubre: Publicación del Orden de Mérito de la 2da Readjudicación en www.salud.sanjuan.gob.ar.
26 de octubre: Adjudicación de cargos de la 2da Readjudicación (especialidad, modalidad y horario a confirmar).
1 de noviembre: Inicio de la residencia en la sede formadora.

📋 Requisitos e Información Importante para Aspirantes
Proceso de Inscripción: Al momento de inscribirse a la beca vacante, deberá enviar un correo electrónico manifestando explícitamente su interés en participar y, de corresponder, el cambio de especialidad solicitado.
Entrevistas: Esta instancia rige únicamente para aquellos profesionales que no pudieron realizar la entrevista en la primera convocatoria.
Criterio de Selección: El Orden de Mérito se confeccionará respetando estrictamente el resultado final obtenido en las instancias previas.`
        };
        this.applyFallbackPdfs(114);
      } else if (id == 115) {
        this.localNote = {
          id: 115,
          Nombre: "ORDEN DE MÉRITO 2° READJUDICACIÓN",
          Fecha_Publicacion: "2026-10-23",
          Cuerpo: `Comunicación Oficial: Órden de Mérito 2° Readjudicación de Becas Vacantes Concurso de Residencias 2026

El Ministerio de Salud de la Provincia de San Juan informa que se encuentra disponible el Órden de Mérito de la 2° Readjudicación de becas vacantes de residencias, Concurso 2026.

En cumplimiento con las normativas provinciales vigentes la Resolución N° 5275-2023, ART. 51 - inc. 6°, establece: "El nuevo órden de mérito es publicado en fecha establecida por cronograma público, se conformará un único ranking por profesión, y se podrá elegir especialidad y sede de residencia por órden de mérito al momento de la toma del cargo".

Cronograma de Fechas Importantes

26 de octubre: Adjudicación de Cargos de 2da Readjudicación (especialidad, modalidad y horario a confirmar).

1 de noviembre: Inicio de Residencia en Sede Formadora.`
        };
        this.applyFallbackPdfs(115);
      } else if (id == 102) {
        this.localNote = {
          id: 102,
          Nombre: "PADRÓN DEFINITIVO DE HABILITADOS PARA RENDIR",
          Fecha_Publicacion: "2026-04-14",
          Cuerpo: `El Ministerio de Salud de la Provincia de San Juan, a través de la División Recursos Humanos y Capacitación,Área Coordinación de Residencias, informa que ya se encuentra disponible el Padrón Definitivo de Inscriptos habilitados para rendir el examen de residencias. Este listado confirma quiénes están autorizados para participar del Examen del Concurso Provincial de Ingreso a las Residencias 2026.

🗓️ Cronograma de fechas importantes
Anotá estas fechas en tu agenda para no perder ningún detalle del proceso:
28 de Mayo: Examen Provincial Presencial. Es la instancia evaluativa obligatoria para todos los postulantes. (Recordar asistir con DNI original y Comprobante de inscripción).
Desde el 29 de Mayo: Inicio de las Entrevistas por Competencias. La sede, la especialidad y el horario de cada entrevista serán confirmados de forma individual a cada postulante a través de correo electrónico.
13 de Julio: Publicación provisoria de notas y período de reclamos. Fecha clave para conocer los resultados y realizar consultas administrativas en caso de ser necesario.

Se recomienda a todos los profesionales mantenerse atentos a sus casillas de correo (incluyendo la carpeta de spam) para recibir las notificaciones sobre el examen y las entrevistas.

Estamos en contacto permanente para ayudarte, escribinos a través del correo oficial: examenresidencias.sanjuan@gmail.com. ante cualquier duda que te surja.`
        };
        this.applyFallbackPdfs(102);
      }
    },
    applyFallbackPdfs(id) {
      if (id == 57 || id == undefined) {
        this.pdfs = [
          { id: 'local_1', title: "Bibliografía Examen Kinesiología 2026", url: "/docs/BIBLIOGRAFIA EXAMEN PARA RESIDENCIA DE KINESIOLOGIA  2026.docx.pdf" },
          { id: 'local_2', title: "Bibliografía Examen Psicología 2026", url: "/docs/BIBLIOGRAFÍA EXAMEN PSICOLOGIA 2026.docx.pdf" },
          { id: 'local_3', title: "Bibliografía Hematología Post Básica 2026", url: "/docs/BIBLIOGRAFIA HEMATOLOGIA POST BASICA 2026.docx.pdf" },
          { id: 'local_4', title: "Bibliografía Neonatología Post Básica 2026", url: "/docs/BIBLIOGRAFIA NEONATOLOGIA POST BASICA 2026.docx.pdf" },
          { id: 'local_5', title: "Bibliografía Examen Enfermería 2026", url: "/docs/BIBLIOGRAFIA PARA EXAMEN DE ENFERMERIA 2026.docx.pdf" },
          { id: 'local_6', title: "Bibliografía Terapia Intensiva Pediátrica 2026", url: "/docs/BIBLIOGRAFIA TERAPIA INTENSIVA PEDIATRICA POST BASICA 2026.docx.pdf" },
          { id: 'local_7', title: "Bibliografía Trabajo Social 2026", url: "/docs/BIBLIOGRAFIA TRABAJO SOCIAL 2026.docx.pdf" },
          { id: 'local_8', title: "Bibliografía Bioquímica 2026", url: "/docs/BIBLIOGRAFÍA BIOQUÍMICA 2026.docx.pdf" },
          { id: 'local_9', title: "Bibliografía Residencias Médicas 2026", url: "/docs/BIBLIOGRAFIA EXAMEN DE RESIDENCIAS MEDICAS 2026 (2).pdf" },
          { id: 'local_10', title: "Bibliografía Ingeniería Clínica 2026", url: "/docs/bibliografia-ing-clinica-2026docx.pdf" }
        ];
      } else if (id == 34) {
        this.pdfs = [
          { id: '7be45e98-7121-47bc-b969-c5954f93c93e', title: "Resolución N° 5275-MSP-2023 - Modificación Reglamento Básico General de Residencias", url: "https://contenidodirecto.sanjuan.gob.ar/assets/7be45e98-7121-47bc-b969-c5954f93c93e" },
          { id: '449032ec-3856-4855-9ad3-a7d7b294c6d3', title: "Resolución 1993/2015", url: "https://contenidodirecto.sanjuan.gob.ar/assets/449032ec-3856-4855-9ad3-a7d7b294c6d3" }
        ];
      } else if (id == 36) {
        this.pdfs = [
          { id: '1eb17538-65d7-49d0-add9-38f9491bbf62', title: "Programa Aprobado Pediatría - 3 Años", url: "https://contenidodirecto.sanjuan.gob.ar/assets/1eb17538-65d7-49d0-add9-38f9491bbf62" },
          { id: '9be163dd-03d0-4dc5-9b64-e6f36d5b48dc', title: "Programa Aprobado RISAMC", url: "https://contenidodirecto.sanjuan.gob.ar/assets/9be163dd-03d0-4dc5-9b64-e6f36d5b48dc" },
          { id: '5c4a1aa8-3527-443f-b61f-45ccf027331a', title: "Programa Urología Aprobado", url: "https://contenidodirecto.sanjuan.gob.ar/assets/5c4a1aa8-3527-443f-b61f-45ccf027331a" },
          { id: '5b5ca91a-774d-464f-ba1d-e1a01dce8cc8', title: "Programa Aprobado de Trabajo Social", url: "https://contenidodirecto.sanjuan.gob.ar/assets/5b5ca91a-774d-464f-ba1d-e1a01dce8cc8" },
          { id: 'f140367d-e36b-4ee6-a4fa-2b4e71ad157a', title: "Programa Aprobado Tocoginecología", url: "https://contenidodirecto.sanjuan.gob.ar/assets/f140367d-e36b-4ee6-a4fa-2b4e71ad157a" },
          { id: 'f5543483-ce0e-4dad-940e-29af8f877fd4', title: "Programa Aprobado Terapia Intensiva Adultos", url: "https://contenidodirecto.sanjuan.gob.ar/assets/f5543483-ce0e-4dad-940e-29af8f877fd4" },
          { id: '602c04dc-df0b-46b5-ac01-1e130c8812a8', title: "Programa Psiquiatría Aprobado", url: "https://contenidodirecto.sanjuan.gob.ar/assets/602c04dc-df0b-46b5-ac01-1e130c8812a8" },
          { id: '44b9ae5e-bd7d-41c9-8ec3-ba1cef321fe5', title: "Programa Psicología Aprobado", url: "https://contenidodirecto.sanjuan.gob.ar/assets/44b9ae5e-bd7d-41c9-8ec3-ba1cef321fe5" },
          { id: 'cc2b7945-2ccd-41e0-a282-bf63dcf27c98', title: "Programa Aprobado de Ortopedia y Traumatología", url: "https://contenidodirecto.sanjuan.gob.ar/assets/cc2b7945-2ccd-41e0-a282-bf63dcf27c98" },
          { id: 'dc34b2d5-8582-45e0-a1c7-5e0df32829fe', title: "Programa Aprobado ORL", url: "https://contenidodirecto.sanjuan.gob.ar/assets/dc34b2d5-8582-45e0-a1c7-5e0df32829fe" },
          { id: 'e73b89a8-7ccc-4064-a547-1c37f95a81bc', title: "Programa Aprobado Oftalmología", url: "https://contenidodirecto.sanjuan.gob.ar/assets/e73b89a8-7ccc-4064-a547-1c37f95a81bc" },
          { id: '947ccc59-809a-4d1a-be81-fe3779f085fc', title: "Programa Aprobado Neurocirugía", url: "https://contenidodirecto.sanjuan.gob.ar/assets/947ccc59-809a-4d1a-be81-fe3779f085fc" },
          { id: '530e0fbd-bb3e-464f-9d91-457aa171292c', title: "Programa Aprobado Neonatología Posbásica", url: "https://contenidodirecto.sanjuan.gob.ar/assets/530e0fbd-bb3e-464f-9d91-457aa171292c" },
          { id: 'c6103332-e310-41b4-bcfe-705525dd8999', title: "Programa Aprobado Neonatología Básica Articulada", url: "https://contenidodirecto.sanjuan.gob.ar/assets/c6103332-e310-41b4-bcfe-705525dd8999" },
          { id: '09757f5d-78e8-43b4-a7b4-46d70ad77623', title: "Programa Aprobado MGF - 3 Años", url: "https://contenidodirecto.sanjuan.gob.ar/assets/09757f5d-78e8-43b4-a7b4-46d70ad77623" },
          { id: 'a84efe3d-d73f-4b1d-aaee-b9f11212354d', title: "Programa Aprobado Enfermería - Cuidado Paliativos", url: "https://contenidodirecto.sanjuan.gob.ar/assets/a84efe3d-d73f-4b1d-aaee-b9f11212354d" },
          { id: 'a4c6b882-4bee-4cd0-8f61-5129eec73a40', title: "Programa Aprobado Infectología", url: "https://contenidodirecto.sanjuan.gob.ar/assets/a4c6b882-4bee-4cd0-8f61-5129eec73a40" },
          { id: '817147ee-35c2-4f29-973e-1de7cf1b3fb8', title: "Programa Farmacia Hospitalaria Aprobado", url: "https://contenidodirecto.sanjuan.gob.ar/assets/817147ee-35c2-4f29-973e-1de7cf1b3fb8" },
          { id: '8be93dc3-0319-4f14-ba1d-5e4e741c4537', title: "Programa Aprobado Enfermería en Salud del Adulto", url: "https://contenidodirecto.sanjuan.gob.ar/assets/8be93dc3-0319-4f14-ba1d-5e4e741c4537" },
          { id: '1f114291-1783-4ff0-b19a-506238bcff10', title: "Aprobación Programa Enfermería en Salud Materno Infantil y Adolescente", url: "https://contenidodirecto.sanjuan.gob.ar/assets/1f114291-1783-4ff0-b19a-506238bcff10" },
          { id: '0539d9d8-9e37-4184-8d80-8b4c276c0080', title: "Programa Anatomía Patológica", url: "https://contenidodirecto.sanjuan.gob.ar/assets/0539d9d8-9e37-4184-8d80-8b4c276c0080" },
          { id: '6428729f-3a0f-41be-b669-3b5527e21d66', title: "Programa Aprobado Enfermería en la Atención del Paciente Crítico Neonatal, Pediátrico y Adulto", url: "https://contenidodirecto.sanjuan.gob.ar/assets/6428729f-3a0f-41be-b669-3b5527e21d66" },
          { id: '5c3a2ddf-abfc-4073-b452-5d55c83d47e4', title: "Programa Aprobado de Diagnóstico por Imágenes", url: "https://contenidodirecto.sanjuan.gob.ar/assets/5c3a2ddf-abfc-4073-b452-5d55c83d47e4" },
          { id: '328d880f-d489-4928-9770-4daeede2e252', title: "Programa Aprobado Cirugía Pediátrica", url: "https://contenidodirecto.sanjuan.gob.ar/assets/328d880f-d489-4928-9770-4daeede2e252" },
          { id: '75e564a9-ae96-4aee-b7b0-1c7b3cb3a2ea', title: "Clínica Médica Aprobado - Programa Conjunto 3 Años", url: "https://contenidodirecto.sanjuan.gob.ar/assets/75e564a9-ae96-4aee-b7b0-1c7b3cb3a2ea" },
          { id: '701163d7-7d55-47b6-abb8-42878c3aa7fa', title: "Cardiología Conjunto 4 Años Aprobado", url: "https://contenidodirecto.sanjuan.gob.ar/assets/701163d7-7d55-47b6-abb8-42878c3aa7fa" },
          { id: '6a3a72bc-b064-4df2-892c-3b8743b36056', title: "Cirugía General - Programa Jurisdiccional Aprobado", url: "https://contenidodirecto.sanjuan.gob.ar/assets/6a3a72bc-b064-4df2-892c-3b8743b36056" },
          { id: '3021bc7b-1d4b-43d3-bfa8-75ef93c9170d', title: "Programa Aprobado Bioquímica", url: "https://contenidodirecto.sanjuan.gob.ar/assets/3021bc7b-1d4b-43d3-bfa8-75ef93c9170d" },
          { id: '0166ba40-f119-47e5-a1fd-d13ed43b513f', title: "Programa Aprobado Residencia en Anestesiología", url: "https://contenidodirecto.sanjuan.gob.ar/assets/0166ba40-f119-47e5-a1fd-d13ed43b513f" }
        ];
      } else if (id == 39) {
        this.pdfs = [
          { id: 'd0139899-ce64-4409-a175-3c11ff4ae138', title: "Resolución N° 1793 MS 2025 Entrevista", url: "https://contenidodirecto.sanjuan.gob.ar/assets/d0139899-ce64-4409-a175-3c11ff4ae138" },
          { id: 'local_cron_1', title: "RESOLUCION N° 5275-MSP-2023 REGLAMENTO MODIFICATORIA REGLAMENTO BASICO GENERAL DE RESIDENCIAS", url: "/docs/RESOLUCION N° 5275-MSP-2023 REGLAMENTO MODIFICATORIA REGLAMENTO BASICO GENERAL DE RESIDENCIAS.pdf" },
          { id: 'local_cron_2', title: "RESOLUCIÓN Nº 1134 MS 2026  BASES CONCURSO 2026.pd", url: "/docs/RESOLUCIÓN Nº 1134 MS 2026  BASES CONCURSO 2026.pdf" },
          { id: 'local_cron_3', title: "RESOLUCIÓN N° 1246-MS-2026 CRONOGRAMA 2026", url: "/docs/RES_1246-2026_Cronograma_de_etapas_inherentes_al_Concurso_Provincial_2026.pdf" },
          { id: 'local_cron_4', title: "RESOLUCIÓN N° 1510-MS-2026 CUPOS", url: "/docs/Resolución 1510-2026-MS-CUPOS.pdf" }
        ];
      } else if (id == 99) {
        this.pdfs = [
          { id: 'local_bio_1', title: "Bibliografía Ingeniería Clínica 2026", url: "/docs/bibliografia-ing-clinica-2026docx.pdf" }
        ];
      } else if (id == 101) {
        this.pdfs = [
          { id: 'local_esp_1', title: "Especialidades y cupos 2026", url: "/docs/especialidades_y_cupos_2026.pdf" }
        ];
      } else if (id == 102) {
        this.pdfs = [
          { id: 'local_padron_1', title: "Padrón Definitivo de Habilitados para Rendir - Concurso 2026", url: "/docs/padron-definitivo-de-inscriptos-san-juan_concurso-2026.pdf" }
        ];
      } else if (id == 104) {
        this.pdfs = [
          { id: 'local_cron_ent_1', title: "Cronograma de Entrevistas - Concurso Residencias 2026", url: "/docs/cronograma-entrevistas-residencias-2026.pdf" }
        ];
      } else if (id == 105) {
        this.pdfs = [
          { id: 'local_ex_med_a', title: "Examen Medicina - Tema A", url: "/docs/examen-2026-medicina-tema-a.pdf" },
          { id: 'local_gr_med_a', title: "Grilla de Corrección Medicina - Tema A", url: "/docs/grilla-2026-medicina-tema-a.pdf" },
          { id: 'local_ex_med_b', title: "Examen Medicina - Tema B", url: "/docs/examen-2026-medicina-tema-b.pdf" },
          { id: 'local_gr_med_b', title: "Grilla de Corrección Medicina - Tema B", url: "/docs/grilla-2026-medicina-tema-b.pdf" },
          { id: 'local_ex_med_c', title: "Examen Medicina - Tema C", url: "/docs/examen-2026-medicina-tema-c.pdf" },
          { id: 'local_gr_med_c', title: "Grilla de Corrección Medicina - Tema C", url: "/docs/grilla-2026-medicina-tema-c.pdf" },
          { id: 'local_ex_med_d', title: "Examen Medicina - Tema D", url: "/docs/examen-2026-medicina-tema-d.pdf" },
          { id: 'local_gr_med_d', title: "Grilla de Corrección Medicina - Tema D", url: "/docs/grilla-2026-medicina-tema-d.pdf" },
          { id: 'local_ex_enf_a', title: "Examen Enfermería - Tema A", url: "/docs/examen-2026-enfermeria-tema-a.pdf" },
          { id: 'local_gr_enf_a', title: "Grilla de Corrección Enfermería - Tema A", url: "/docs/grilla-2026-enfermeria-tema-a.pdf" },
          { id: 'local_ex_enf_b', title: "Examen Enfermería - Tema B", url: "/docs/examen-2026-enfermeria-tema-b.pdf" },
          { id: 'local_gr_enf_b', title: "Grilla de Corrección Enfermería - Tema B", url: "/docs/grilla-2026-enfermeria-tema-b.pdf" },
          { id: 'local_ex_bioq', title: "Examen Bioquímica", url: "/docs/examen-2026-bioquimica.pdf" },
          { id: 'local_gr_bioq', title: "Grilla de Corrección Bioquímica", url: "/docs/grilla-2026-bioquimica.pdf" },
          { id: 'local_ex_hema', title: "Examen Hematología (Postbásica)", url: "/docs/examen-2026-hematologia-postbasica.pdf" },
          { id: 'local_gr_hema', title: "Grilla de Corrección Hematología (Postbásica)", url: "/docs/grilla-2026-hematologia-postbasica.pdf" },
          { id: 'local_ex_ing', title: "Examen Ingeniería Clínica", url: "/docs/examen-2026-ingenieria-clinica.pdf" },
          { id: 'local_gr_ing', title: "Grilla de Corrección Ingeniería Clínica", url: "/docs/grilla-2026-ingenieria-clinica.pdf" },
          { id: 'local_ex_kine', title: "Examen Kinesiología", url: "/docs/examen-2026-kinesiologia.pdf" },
          { id: 'local_gr_kine', title: "Grilla de Corrección Kinesiología", url: "/docs/grilla-2026-kinesiologia.pdf" },
          { id: 'local_ex_neo', title: "Examen Neonatología (Postbásica)", url: "/docs/examen-2026-neonatologia-postbasica.pdf" },
          { id: 'local_gr_neo', title: "Grilla de Corrección Neonatología (Postbásica)", url: "/docs/grilla-2026-neonatologia-postbasica.pdf" },
          { id: 'local_ex_psico', title: "Examen Psicología", url: "/docs/examen-2026-psicologia.pdf" },
          { id: 'local_gr_psico', title: "Grilla de Corrección Psicología", url: "/docs/grilla-2026-psicologia.pdf" },
          { id: 'local_ex_tip', title: "Examen Terapia Intensiva Pediátrica (Postbásica)", url: "/docs/examen-2026-terapia-intensiva-pediatrica-postbasica.pdf" },
          { id: 'local_gr_tip', title: "Grilla de Corrección Terapia Intensiva Pediátrica (Postbásica)", url: "/docs/grilla-2026-terapia-intensiva-pediatrica-postbasica.pdf" },
          { id: 'local_ex_ts', title: "Examen Trabajo Social", url: "/docs/examen-2026-trabajo-social.pdf" },
          { id: 'local_gr_ts', title: "Grilla de Corrección Trabajo Social", url: "/docs/grilla-2026-trabajo-social.pdf" }
        ];
      } else if (id == 106) {
        this.pdfs = [
          { id: 'local_puntaje_106', title: "Puntaje Examen - Inscriptos Concurso San Juan 2026", url: "/docs/Puntaje Examen-Inscriptos Concurso SJ 2026.pdf" }
        ];
      } else if (id == 107) {
        this.pdfs = [
          { id: 'local_apelaciones_107', title: "Respuestas a Instancia de Apelaciones", url: "/docs/Respuestas a instancia de apelaciones.pdf" }
        ];
      } else if (id == 108) {
        this.pdfs = [
          { id: 'local_om_anestesiologia', title: "Orden de Mérito Anestesiología 2026", url: "/docs/ORDEN MERITO ANESTESIOLOGIA 2026.pdf" },
          { id: 'local_om_bioquimica', title: "Orden de Mérito Bioquímica Clínica 2026", url: "/docs/ORDEN MERITO BIOQUIMICA CLINICA 2026.pdf" },
          { id: 'local_om_cardiologia', title: "Orden de Mérito Cardiología 2026", url: "/docs/ORDEN MERITO CARDIOLOGIA 2026.pdf" },
          { id: 'local_om_cirugia', title: "Orden de Mérito Cirugía General 2026", url: "/docs/ORDEN MERITO CIRUGIA GENERAL 2026.pdf" },
          { id: 'local_om_clinica', title: "Orden de Mérito Clínica Médica 2026", url: "/docs/ORDEN MERITO CLINICA MEDICA 2026.pdf" },
          { id: 'local_om_imagenes', title: "Orden de Mérito Diagnóstico por Imágenes 2026", url: "/docs/ORDEN MERITO DIAGNOSTICO POR IMAGENES 2026.pdf" },
          { id: 'local_om_enf_cc_adultos', title: "Orden de Mérito Enfermería Cuidados Críticos Adultos 2026", url: "/docs/ORDEN MERITO ENFERMERIA CUIDADOS CRITICOS ADULTOS 2026.pdf" },
          { id: 'local_om_enf_cc_neonatal', title: "Orden de Mérito Enfermería Cuidados Críticos Neonatal 2026", url: "/docs/ORDEN MERITO ENFERMERIA CUIDADOS CRITICOS NEONATAL 2026.pdf" },
          { id: 'local_om_enf_cc_pediatricos', title: "Orden de Mérito Enfermería Cuidados Críticos Pediátricos 2026", url: "/docs/ORDEN MERITO ENFERMERIA CUIDADOS CRITICOS PEDIATRICOS 2026.pdf" },
          { id: 'local_om_enf_paliativos', title: "Orden de Mérito Enfermería Cuidados Paliativos 2026", url: "/docs/ORDEN MERITO ENFERMERIA CUIDADOS PALIATIVOS 2026.pdf" },
          { id: 'local_om_enf_adulto', title: "Orden de Mérito Enfermería en Salud del Adulto 2026", url: "/docs/ORDEN MERITO ENFERMERIA EN SALUD DEL ADULTO 2026.pdf" },
          { id: 'local_om_enf_materno', title: "Orden de Mérito Enfermería Salud Materno Infantil y del Adolescente 2026", url: "/docs/ORDEN MERITO ENFERMERIA SALUD MATERNO INFANTIL Y DEL ADOLESCENTE 2026.pdf" },
          { id: 'local_om_hematologia', title: "Orden de Mérito Hematología (Postbásica) 2026", url: "/docs/ORDEN MERITO HEMATOLOGIA PB 2026.pdf" },
          { id: 'local_om_ing_clinica', title: "Orden de Mérito Ingeniería Clínica 2026", url: "/docs/ORDEN MERITO INGENIERIA CLINICA 2026.pdf" },
          { id: 'local_om_kinesiologia', title: "Orden de Mérito Kinesiología Cardiorrespiratoria 2026", url: "/docs/ORDEN MERITO KINESIOLOGIA CARDIORRESPIRATORIA 2026.pdf" },
          { id: 'local_om_mgf', title: "Orden de Mérito Medicina General y Familiar 2026", url: "/docs/ORDEN MERITO MEDICINA GENERAL Y FAMILIAR 2026.pdf" },
          { id: 'local_om_neo_basica', title: "Orden de Mérito Neonatología Básica Articulada 2026", url: "/docs/ORDEN MERITO NEONATOLOGIA BASICA ARTICULADA 2026.pdf" },
          { id: 'local_om_neo_pb', title: "Orden de Mérito Neonatología (Postbásica) 2026", url: "/docs/ORDEN MERITO NEONATOLOGIA PB 2026.pdf" },
          { id: 'local_om_neurocirugia', title: "Orden de Mérito Neurocirugía 2026", url: "/docs/ORDEN MERITO NEUROCIRUGIA 2026.pdf" },
          { id: 'local_om_oftalmologia', title: "Orden de Mérito Oftalmología 2026", url: "/docs/ORDEN MERITO OFTALMOLOGIA 2026.pdf" },
          { id: 'local_om_orl', title: "Orden de Mérito Otorrinolaringología 2026", url: "/docs/ORDEN MERITO ORL 2026.pdf" },
          { id: 'local_om_ortopedia', title: "Orden de Mérito Ortopedia y Traumatología 2026", url: "/docs/ORDEN MERITO ORTOPEDIA Y TRAUMATOLOGIA 2026.pdf" },
          { id: 'local_om_pediatria', title: "Orden de Mérito Pediatría 2026", url: "/docs/ORDEN MERITO PEDIATRIA 2026.pdf" },
          { id: 'local_om_psicologia', title: "Orden de Mérito Psicología Clínica 2026", url: "/docs/ORDEN MERITO PSICOLOGIA CLINICA 2026.pdf" },
          { id: 'local_om_psiquiatria', title: "Orden de Mérito Psiquiatría 2026", url: "/docs/ORDEN MERITO PSIQUIATRIA 2026.pdf" },
          { id: 'local_om_risamc', title: "Orden de Mérito RISAMC 2026", url: "/docs/ORDEN MERITO RISAMC 2026.pdf" },
          { id: 'local_om_tia', title: "Orden de Mérito Terapia Intensiva Adultos 2026", url: "/docs/ORDEN MERITO TERAPIA INTENSIVA ADULTOS 2026.pdf" },
          { id: 'local_om_tii', title: "Orden de Mérito Terapia Intensiva Infantil (Postbásica) 2026", url: "/docs/ORDEN MERITO TERAPIA INTENSIVA INFANTIL PB 2026.pdf" },
          { id: 'local_om_tocoginecologia', title: "Orden de Mérito Tocoginecología 2026", url: "/docs/ORDEN MERITO TOCOGINECOLOGIA 2026.pdf" },
          { id: 'local_om_trabajo_social', title: "Orden de Mérito Trabajo Social 2026", url: "/docs/ORDEN MERITO TRABAJO SOCIAL 2026.pdf" }
        ];
      } else if (id == 109) {
        this.pdfs = [
          { id: 'local_fe_erratas_risamc_109', title: "Orden de Mérito RISAMC 2026 (Rectificado)", url: "/docs/FE DE ERRATAS ORDEN MERITO RISAMC 2026.pdf" }
        ];
      } else if (id == 110) {
        this.pdfs = [
          { id: 'local_cronograma_adjudicacion_110', title: "Cronograma Acto de Adjudicación 2026", url: "/docs/CRONOGRAMA ACTO ADJUDICACION 2026.pdf" }
        ];
      } else if (id == 112) {
        this.pdfs = [
          { id: 'local_readjudicacion_112', title: "Especialidades y Cupos 2026 - 1era Readjudicación", url: "/docs/especialidades-y-cupos-2026-1era-readjudicacion.pdf" }
        ];
      } else if (id == 113) {
        this.pdfs = [
          { id: 'local_om_med_113', title: "Orden de Mérito Medicina - 1ra Readjudicación 2026", url: "/docs/ORDEN_MERITO_MEDICINA_1__READJUDICACION_2026.pdf" },
          { id: 'local_om_enf_113', title: "Orden de Mérito Enfermería - 1ra Readjudicación 2026", url: "/docs/ORDEN_MERITO_ENFERMERIA_1__READJUDICACION_2026.pdf" },
          { id: 'local_om_risamc_113', title: "Orden de Mérito RISAMC / Trabajo Social - 1ra Readjudicación 2026", url: "/docs/ORDEN_MERITO_RISAMC_TRABAJO_SOCIAL_1__READJUDICACION_2026.pdf" }
        ];
      } else if (id == 114) {
        this.pdfs = [
          { id: 'local_readjudicacion_114', title: "Especialidades y Cupos 2026 - 2da Readjudicación", url: "/docs/especialidades-y-cupos-2026-2da-readjudicacion.pdf" }
        ];
      } else if (id == 115) {
        this.pdfs = [
          { id: 'local_om_med_115', title: "Orden de Mérito Medicina - 2da Readjudicación 2026", url: "/docs/ORDEN_MERITO_MEDICINA_2__READJUDICACION_2026.pdf" }
        ];
      }
    },
    getPdfUrl(pdf) {
      // Si el PDF tiene una URL definida (nuestro fallback local), la usamos directamente
      if (pdf.url) return pdf.url;

      const baseUrl = process.env.VUE_APP_DIRECTUS_URL || "https://contenidodirecto.sanjuan.gob.ar";
      return `${baseUrl}/assets/${pdf.id}`;
    },
    goHome() {
      // Modo inline (renderizado dentro de la lista): colapsa el acordeón.
      // Modo standalone (ruta ?uid=DETALLE-NOTA): vuelve al inicio.
      if (this.note) {
        this.$emit("close");
      } else {
        window.location.href = window.location.origin;
      }
    },
    parseLinks(text) {
      if (!text) return "";
      // Enlaces con texto personalizado: [LINK:URL|Texto]
      let html = text.replace(
        /\[LINK:(https?:\/\/[^\]|]+)\|([^\]]+)\]/g,
        (match, url, label) => `<a href="${url}" target="_blank">${label}</a>`
      );
      // Enlaces simples: [LINK:URL]
      html = html.replace(
        /\[LINK:(https?:\/\/[^\]\s]+)\]/g,
        (match, url) => `<a href="${url}" target="_blank">${url}</a>`
      );
      // Listas: líneas que empiezan con "- "
      html = html.replace(/(^|\n)- (.*)/g, "$1<br>&bull; $2");
      // Separadores: líneas con guiones largos
      html = html.replace(/-{5,}/g, "<hr>");
      // Saltos de línea dobles -> párrafos
      html = html.replace(/\n\n+/g, "<br><br>");
      // Saltos de línea simples
      html = html.replace(/\n/g, "<br>");
      return html;
    },
  },
};
</script>

<style scoped>
.document-detail {
  max-width: 1250px;
  /* antes 1100px */
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 2.5rem 2rem;
}

@media (max-width: 900px) {
  .document-detail {
    max-width: 98vw;
    padding: 1.5rem 1rem;
  }
}

@media (max-width: 600px) {
  .document-detail {
    padding: 1rem 0.5rem;
    max-width: 100vw;
  }

  .detail-title {
    font-size: 1.3rem;
  }

  .detail-body {
    font-size: 1rem;
  }
}

.detail-header {
  border-bottom: 1px solid #eee;
  margin-bottom: 1.5rem;
}

.detail-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #a52a2a;
}

.detail-date {
  font-size: 1rem;
  color: #888;
}

.detail-body {
  font-size: 1.1rem;
  line-height: 1.7;
  margin-bottom: 1.5rem;
}

.detail-body ::v-deep a {
  color: #1976d2 !important;
  text-decoration: underline;
  transition: color 0.2s;
}

.detail-body ::v-deep a:hover {
  color: #d32f2f !important;
  /* Rojo */
}

.detail-pdfs h4 {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

.pdf-list {
  list-style: none;
  padding: 0;
  width: 100%;
  /* Asegura que la lista ocupe todo el ancho disponible */
}

.pdf-link {
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #d32f2f;
  text-decoration: none;
  margin-bottom: 0.5rem;
  transition: color 0.2s;
  word-break: break-word;
  /* Permite cortar palabras largas */
  flex-wrap: wrap;
  /* Permite que el texto pase a otra línea */
  min-width: 0;
  /* Para que el texto respete el ancho del contenedor */
  max-width: 100%;
  /* No se salga del contenedor */
}

.pdf-link:hover {
  color: #a52a2a;
  text-decoration: underline;
}

.pdf-icon {
  margin-right: 8px;
  font-size: 1.2em;
}
</style>
